import { render } from "./persoonlijke-gegevens-step.vue?vue&type=template&id=19c66772"
import script from "./persoonlijke-gegevens-step.vue?vue&type=script&lang=js"
export * from "./persoonlijke-gegevens-step.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__